import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=70b865a7&scoped=true&"
import script from "./Listado.vue?vue&type=script&lang=js&"
export * from "./Listado.vue?vue&type=script&lang=js&"
import style0 from "./Listado.vue?vue&type=style&index=0&id=70b865a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b865a7",
  null
  
)

export default component.exports